<template>
  <div>
    <div v-if="clientRules.length == 0">
      <button class="btn btn-primary" @click="createDetaultRules">
        Crear Regla por default
      </button>
    </div>
    <select name="" class="form-control" id="" v-model="typeProjectId">
      <option
        v-for="tab in clientTabRules"
        :key="tab.id"
        :value="tab.id"
      >
        {{ tab.name }}
      </option>
    </select>

    <table class="table" v-if="rulesForTable.length > 0">
      <thead>
        <tr>
          <th>Tipo de informacion</th>
          <th>Cantidad requerida</th>
          <th>Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(rule, index) in rulesForTable" :key="rule.id">
          <td>{{ rule.type_references | translateAssignmentType }}</td>
          <td>{{ rule.number_references_require }}</td>
          <td>
            <button
              class="btn btn-primary"
              @click="openModalActions(rule.id, rule.number_references_require, index)"
              type=""
            >
              Editar
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <button
      style="visibility: hidden"
      type="button"
      class="btn btn-primary"
      data-toggle="modal"
      data-target="#exampleModal"
      id="btnModalClick"
    >
      Launch demo modal
    </button>
    <modal-actions
      :rule_id="ruleId"
      :number_references_require="number_references_require"
      @eventupdate="updateProps"
      @update-item="updateItem"
    />
  </div>
</template>

<script>
import axios from "axios";
import ModalActions from "./modal-actions";
export default {
  props: ["client_id"],
  name: "TableClientRules",
  data() {
    return {
      clientRules: [],
      clientTabRules: [],
      clientCategoryRules: [],
      rulesForTable: [],
      ruleId: 0,
      number_references_require: 0,
      index: 0,
      clientsCreated: false,
      typeProjectId: null
    };
  },
  methods: {
    setCredentials() {
      this.token = document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content");
      axios.defaults.headers["x-csrf-token"] = this.token;
      axios.defaults.headers.common["Accept"] = "application/json";
      axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
    },
    async getClientRules() {
      let result;
      try {
        this.setCredentials();
        result = await axios.get(`/api/v1/clients/rules?client_id=${this.client_id}`);
        this.clientRules = result.data.rules;
        this.createTabs();
        this.createCategories();
      } catch (error) {
        console.log(error);
      }
    },
    createTabs() {
      this.clientRules.forEach((el) => {
        if (
          this.clientTabRules.filter((data) => data.name == el.project_type_name).length <
          1
        ) {
          this.clientTabRules.push({
            name: el.project_type_name,
            id: el.project_type_id,
          });
        }
      });
    },
    createCategories() {
      this.clientTabRules.forEach((tab) => {
        let category = {
          title: tab.name,
          id: tab.id,
          rules: [],
        };
        this.clientRules.forEach((rule) => {
          if (rule.project_type_id == tab.id) {
            category.rules.push(rule);
          }
        });
        this.clientCategoryRules.push(category);
      });
    },
    viewRulesForProjectType() {
      this.rulesForTable = this.clientCategoryRules.filter(
        (category) => category.id == this.typeProjectId
      )[0].rules;
    },
    openModalActions(id, numberRefereces, index) {
      this.ruleId = id;
      this.index = index;
      this.number_references_require = numberRefereces;
      document.getElementById("btnModalClick").click();
    },
    updateProps(val) {
      this.number_references_require = val;
    },
    updateItem(val) {
      this.rulesForTable[this.index].number_references_require = val;
    },
    async createDetaultRules() {
      let result;
      try {
        this.setCredentials();
        result = await axios.post(
          `/api/v1/clients/${this.client_id}/create_default_rules`
        );
        this.clientsCreated = true;
        console.log(result);
      } catch (error) {}
    },
  },
  filters: {
    translateAssignmentType(assignment) {
      switch (assignment) {
        case "academic_references":
          return "Referencias Academicas";
        case "laboral_references":
          return "Referencias Laborales";
        case "personal_references":
          return "Referencias Personales";
        case "family_references":
          return "Referencias Familiares";
      }
    },
  },
  components: {
    "modal-actions": ModalActions,
  },
  created() {
    this.getClientRules();
  },
  watch: {
    clientsCreated() {
      this.getClientRules();
    },
    typeProjectId () {
      this.viewRulesForProjectType()
    }
  },
};
</script>

<style lang="" scoped></style>
